import { APP_USAGE_METRIC_KEYS } from "@congrs/schemas";

import { roundOneDecimal } from "./utils";

// Keep sum at 100 by spreading the delta proportionally across the other
// 16 metrics. If they all sit at 0, split the remainder evenly so the
// user can still recover from a fully-zeroed state.
export const rescaleAfterEdit = (weights, changedKey, rawValue) => {
  const newValue = Math.max(0, Math.min(100, roundOneDecimal(rawValue)));
  const otherKeys = APP_USAGE_METRIC_KEYS.filter((k) => k !== changedKey);
  const remaining = 100 - newValue;
  const otherSum = otherKeys.reduce((a, k) => a + (weights[k] ?? 0), 0);

  const next = { ...weights, [changedKey]: newValue };
  if (otherSum <= 0) {
    const each = roundOneDecimal(remaining / otherKeys.length);
    for (const k of otherKeys) {
      next[k] = each;
    }
  } else {
    const factor = remaining / otherSum;
    for (const k of otherKeys) {
      next[k] = roundOneDecimal((weights[k] ?? 0) * factor);
    }
  }

  const sum = APP_USAGE_METRIC_KEYS.reduce((a, k) => a + (next[k] ?? 0), 0);
  const drift = roundOneDecimal(100 - sum);
  if (drift !== 0) {
    const target = otherKeys.reduce((best, k) =>
      (next[k] ?? 0) > (next[best] ?? 0) ? k : best
    );
    next[target] = roundOneDecimal(Math.max(0, (next[target] ?? 0) + drift));
  }
  return next;
};
